import { useState } from 'react';
import { useTheme } from '@mui/material/styles';

type TransitionControlPointProps = {
	id: string;
	x: number;
	y: number;
	selected?: boolean;
	onDragStart: (id: string) => void;
	onDrag: (id: string, x: number, y: number) => void;
	onDragEnd: () => void;
	onRemove: (id: string) => void;
};

export function TransitionControlPoint({ id, x, y, selected, onDragStart, onDrag, onDragEnd, onRemove }: TransitionControlPointProps) {
	const [isDragging, setIsDragging] = useState(false);
	const theme = useTheme();

	const handleMouseDown = (e: React.MouseEvent) => {
		e.stopPropagation();
		setIsDragging(true);
		onDragStart(id);

		const handleMouseMove = (moveEvent: MouseEvent) => {
			onDrag(id, moveEvent.clientX, moveEvent.clientY);
		};

		const handleMouseUp = () => {
			setIsDragging(false);
			onDragEnd();
			document.removeEventListener('mousemove', handleMouseMove);
			document.removeEventListener('mouseup', handleMouseUp);
		};

		document.addEventListener('mousemove', handleMouseMove);
		document.addEventListener('mouseup', handleMouseUp);
	};

	const handleDoubleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
		onRemove(id);
	};

	if (!selected) return null;

	return (
		<div
			style={{
				position: 'absolute',
				transform: `translate(-50%, -50%) translate(${x}px, ${y}px)`,
				pointerEvents: 'all',
				cursor: isDragging ? 'grabbing' : 'grab',
				zIndex: 1001,
			}}
			className="nodrag nopan"
			onMouseDown={handleMouseDown}
			onDoubleClick={handleDoubleClick}
			title="Drag to move, double-click to remove"
		>
			<div
				style={{
					width: '12px',
					height: '12px',
					borderRadius: '50%',
					backgroundColor: theme.palette.primary.main,
					border: `2px solid ${theme.palette.background.paper}`,
					boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
				}}
			/>
		</div>
	);
}
